<template>
  <div
    class="cond-btn-wrap"
    @click="changeState"
    :class="[readonly ? 'readonly' : '']"
  >
    <div
      class="state"
      v-for="state in states"
      :class="[true ? state : '', state === value ? 'active' : '']"
      :key="state"
    >
      <span v-if="state === 'AND'">{{
        $t('Audience_Segment_Condition_And').toUpperCase()
      }}</span>
      <span v-if="state === 'OR'">{{
        $t('Audience_Segment_Condition_Or').toUpperCase()
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditionButton',
  props: {
    value: {
      type: [String],
      validator: value => {
        return ['OR', 'AND'].indexOf(value) !== -1
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      states: ['AND', 'OR']
    }
  },
  mounted() {
    if (!this.value) {
      this.$emit('input', 'and')
    }
  },
  methods: {
    changeState() {
      if (!this.readonly) {
        this.$emit(
          'input',
          this.value.indexOf('OR') ? this.states[1] : this.states[0]
        )
        if (this.callback) {
          this.callback()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cond-btn-wrap {
  border: 1px solid #1d87c8;
  box-sizing: border-box;
  border-radius: 4px;
  width: 103px;
  height: 40px;
  margin: 1px;
  cursor: pointer;
  user-select: none;
}
.state {
  margin-top: 4px;
  margin-left: 3px;
  border-radius: 4px;
  height: 30px;
  flex-direction: row;
  display: flex;
  text-align: center;
  justify-content: center;
  float: left;
  width: 46px;

  span {
    color: #1d87c8;
    display: flex;
    align-items: center;
    align-self: center;
  }
}
.active {
  background-color: #1d87c8;
  span {
    color: white;
  }
}
.readonly {
  width: 54px;
  cursor: default;
}
.readonly .state:not(.active) {
  display: none;
}
.readonly .active {
  background-color: #58a4d2;
  span {
    color: white;
  }
}
.and {
  margin-left: 3px;
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/ConditionButton.vue